import type { AddPageRefusalReason } from '@/types/plan'

/** The toast line for each reason the server refuses to add a page with. */
export const ADD_PAGE_REFUSAL_MESSAGES = {
  editor_role_required: 'strategy.addPage.refusals.editorRequired',
  plan_run_in_progress: 'errors.planRun.inProgress',
  page_exists: 'strategy.addPage.refusals.pageExists',
  brand_facts_missing: 'errors.planRun.brandFactsMissing',
  brand_market_undecided: 'errors.planRun.marketUndecided',
  vendor_not_configured: 'errors.planRun.vendorNotConfigured',
  vendor_budget_exhausted: 'errors.planRun.vendorBudgetExhausted',
  page_not_fit: 'strategy.addPage.refusals.notFit',
  model_output_invalid: 'errors.planRun.modelOutputInvalid',
} as const satisfies Record<AddPageRefusalReason, string>

/** A page the person asks for: the question it answers and, when given, the keyword to measure. */
export interface AddPageRequest {
  question: string
  keyword?: string
}
